import { useId } from "react";
import { TextArea } from "@heroui/react";
import type { DossierNotes } from "./useDossierNotes";
import styles from "./Notes.module.scss";

/* UI-DESIGN: a restrained handwritten area lives inside the existing glass,
   with a plain label and explicit local-save status rather than another card. */
export default function NoteField({ label, value, onChange, notes, quiet = false }: {
  quiet?: boolean; label: string; value: string; onChange: (text: string) => void; notes: DossierNotes;
}) {
  const id = useId();
  return <div className={`${styles.field} ${quiet ? styles.quiet : ""}`}>
    <label htmlFor={id} className={styles.label}>{label}</label>
    <TextArea id={id} aria-describedby={`${id}-status`} className={styles.input}
      value={value} onChange={event => onChange(event.target.value)} disabled={!notes.enabled}
      maxLength={4000} rows={4} placeholder="What have you noticed?" />
    <p id={`${id}-status`} role="status" className={notes.failed ? styles.error : styles.status}>{notes.status}</p>
  </div>;
}
